import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X, MessageCircle } from "lucide-react";
import { scrollToId, whatsappLink } from "@/site-data";

const LINKS = [
  { label: "Hizmetler", href: "#hizmetler", testid: "nav-link-services" },
  { label: "Neden Biz", href: "#neden-biz", testid: "nav-link-why-us" },
  { label: "Yorumlar", href: "#yorumlar", testid: "nav-link-testimonials" },
  { label: "SSS", href: "#sss", testid: "nav-link-faq" },
  { label: "İletişim", href: "#iletisim", testid: "nav-link-contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const go = (e, href) => {
    e.preventDefault();
    setOpen(false);
    scrollToId(href);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#0D1B5E]/85 backdrop-blur-xl border-b border-[#2E4390]/50">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3 md:px-8">
        <a
          href="#"
          data-testid="nav-brand-logo"
          onClick={(e) => {
            e.preventDefault();
            setOpen(false);
            scrollToId("#top");
          }}
          className="flex items-center gap-3"
        >
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-white p-1 shadow-[0_0_20px_rgba(30,127,255,0.35)]">
            <img src="/assets/ecn-logo.png" alt="ECN Dijital Logo" className="h-full w-full object-contain" />
          </span>
          <span className="font-syne text-sm font-bold tracking-[0.18em] hidden sm:block">
            ECN <span className="text-[#1E7FFF]">DİJİTAL</span>
          </span>
        </a>

        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              onClick={(e) => go(e, l.href)}
              className="text-sm font-medium text-[#B9C4E8] transition-colors duration-300 hover:text-[#5CA3FF]"
            >
              {l.label}
            </a>
          ))}
          <a
            href={whatsappLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-cta-whatsapp"
            className="flex items-center gap-2 rounded-full bg-[#25D366] px-5 py-2 text-sm font-semibold text-[#052E16] transition-transform duration-300 hover:scale-105"
          >
            <MessageCircle size={16} />
            WhatsApp
          </a>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="flex h-10 w-10 items-center justify-center rounded-lg border border-[#2E4390] text-[#F8FAFC] md:hidden"
          aria-label="Menü"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
            className="overflow-hidden border-t border-[#2E4390]/50 md:hidden"
          >
            <div className="flex flex-col gap-1 px-5 py-4">
              {LINKS.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  data-testid={`${l.testid}-mobile`}
                  onClick={(e) => go(e, l.href)}
                  className="rounded-lg px-3 py-3 text-sm font-medium text-[#B9C4E8] hover:bg-[#122263] hover:text-[#5CA3FF]"
                >
                  {l.label}
                </a>
              ))}
              <a
                href={whatsappLink()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="nav-cta-whatsapp-mobile"
                className="mt-2 flex items-center justify-center gap-2 rounded-full bg-[#25D366] px-5 py-3 text-sm font-semibold text-[#052E16]"
              >
                <MessageCircle size={16} />
                WhatsApp ile Yaz
              </a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}
